import React from 'react';
import Hero from '../../components/pages/Home/Hero/Hero';
import TTG from '../../components/pages/Home/TTG/TTG';
import WhatWeDo from '../../components/pages/Home/WhatWeDo/WhatWeDo';
import GlobalMarkets from '../../components/pages/Home/GlobalMarkets/GlobalMarkets';
import WealthAndSavings from '../../components/pages/Home/WealthAndSavings/WealthAndSavings';
import Markets from '../../components/pages/Home/Markets/Markets';
import Ready from '../../components/pages/Home/Ready/Ready';

const Home = () => {
  return (
    <div>
      <Hero />
      <TTG />
      <WhatWeDo />
      <GlobalMarkets />
      <WealthAndSavings />
      <Markets />
      <Ready />
    </div>
  );
};

export default Home;
